import { UnderwritingPaidType } from './UnderwritingPaidType';

export const UnderwritingPaidTypeOptions = [
    {
        id: UnderwritingPaidType.Yes,
        name: 'Yes',
        shortName: 'Yes',
    },
    {
        id: UnderwritingPaidType.No,
        name: 'No',
        shortName: 'No',
    },
    {
        id: UnderwritingPaidType.NA,
        name: 'N/A',
        shortName: 'N/A',
    },
];
